export default __webpack_public_path__ + "static/media/adaptation_blind_people.123e90bf.svg";